import { Grid } from '@mui/material'
import { CNoneOption } from '@Constants/common.constant'
import { EAuthReground } from '@Enum/auth.enum'
import { MCity, MState } from '@Models/auth.model'
import { ISelectOptions } from '@Models/common.model'
import { ChangeEvent } from 'react'
import { Controller } from 'react-hook-form'
import { connect } from 'react-redux'
import * as Redux from 'redux'
import { APIServices } from '@Services/api.service'
import { CommonService } from '@Services/common.service'
import AuthAction from '@Stores/auth/auth.action'
import BaseDatePicker from '@Components/Form/BaseDatePicker/BaseDatePicker'
import BaseSelect from '@Components/Form/BaseSelect/BaseSelect'
import { RedditTextField } from '@Components/Form/RedditTextField/RedditTextField'
import InputMask from 'react-input-mask'
import { FormService } from '@Services/form.service'
import BaseCreatableSelect from '@Components/Form/BaseCreatableSelect/BaseCreatableSelect'
import moment from 'moment'

// dummy data
const coverageOptions: ISelectOptions[] = [
    {
        name: 'Liability',
        value: 'LIABILITY',
    },
    {
        name: 'Full',
        value: 'FULL',
    },
]

// models section
interface IInsuranceForm {
    control: any
    errors: any
    setValue: any
    watch: any
    disabled: boolean

    getReground: (type: string, parentId: string, stepTwo?: string) => void
    clearReground: (types: string[]) => void
    states?: MState[]
    cities?: MCity[]
}

function InsuranceForm(props: IInsuranceForm) {
    // core section
    const {
        getReground,
        clearReground,
        control,
        errors,
        setValue,
        states,
        cities,
        watch,
        disabled,
    } = props
    const classesInput = 'reddit-input w-100'

    // functions section
    /**
     * handle select changed
     * @param id reground (country, city, state) id/code
     * @param type action type
     * @returns
     */
    const onHandleSelect = (id: any, type: string) => {
        APIServices.axiosConfig()
        switch (type) {
            case 'STATE':
                setValue('city', null)
                clearReground([EAuthReground.CITIES])
                if (!id) return
                getReground('CITY', id, 'CITY')
                break
            default:
                break
        }
    }

    // main section
    return (
        <Grid container spacing={3} className="mb-4">
            <Grid item sm={8} xs={12} container spacing={2}>
                <Grid item xs={6} className="pt-2">
                    <Controller
                        control={control}
                        name="carrier"
                        defaultValue=""
                        rules={{ required: true }}
                        render={({
                            field: { ref, value, onChange, ...field },
                        }: any) => (
                            <RedditTextField
                                {...field}
                                value={value}
                                onChange={onChange}
                                inputRef={ref}
                                label="Carrier"
                                variant="filled"
                                className={classesInput}
                                error={errors?.carrier && true}
                                helperText={FormService.getErrorMessage(
                                    errors,
                                    'carrier',
                                    'Carrier'
                                )}
                                disabled={disabled}
                                onKeyPress={(e: any) =>
                                    CommonService.allowsInput(e, [
                                        'alphabet',
                                        'numeric',
                                        'space',
                                    ])
                                }
                            />
                        )}
                    />
                </Grid>
                <Grid item xs={6} className="pt-2">
                    <Controller
                        control={control}
                        name="phone"
                        defaultValue=""
                        rules={{ required: true }}
                        render={({
                            field: { ref, value, onChange, ...fields },
                        }: any) => (
                            <RedditTextField
                                {...fields}
                                value={value}
                                onChange={onChange}
                                inputRef={ref}
                                label="Telephone"
                                variant="filled"
                                className={classesInput}
                                error={errors?.phone && true}
                                helperText={FormService.getErrorMessage(
                                    errors,
                                    'phone',
                                    'Telephone'
                                )}
                                onKeyPress={CommonService.phoneNumber}
                                fullWidth
                                disabled={disabled}
                            />
                        )}
                    />
                </Grid>
                <Grid item xs={6} className="pt-2">
                    <Controller
                        control={control}
                        name="address"
                        defaultValue=""
                        rules={{ required: true }}
                        render={({
                            field: { ref, value, onChange, ...field },
                        }: any) => (
                            <RedditTextField
                                {...field}
                                value={value}
                                onChange={onChange}
                                inputRef={ref}
                                label="Address"
                                variant="filled"
                                className={classesInput}
                                error={errors?.address && true}
                                helperText={FormService.getErrorMessage(
                                    errors,
                                    'address',
                                    'Address'
                                )}
                                disabled={disabled}
                                onKeyPress={(e: any) =>
                                    CommonService.allowsInput(e, [
                                        'alphabet',
                                        'numeric',
                                        'space',
                                    ])
                                }
                            />
                        )}
                    />
                </Grid>
                <Grid item xs={6} className="pt-2">
                    <Controller
                        control={control}
                        name="state"
                        defaultValue=""
                        rules={{ required: true }}
                        render={({
                            field: { ref, value, onChange, ...field },
                        }: any) => (
                            <BaseCreatableSelect
                                label="State"
                                options={states}
                                value={value}
                                onChange={(e: any) => {
                                    onChange(e)
                                    onHandleSelect(e, 'STATE')
                                }}
                                // inputRef={ref}
                                fullWidth
                                className={classesInput}
                                error={errors?.state && true}
                                helperText={FormService.getErrorMessage(
                                    errors,
                                    'state',
                                    'State'
                                )}
                                disabled={disabled}
                            />
                        )}
                    />
                </Grid>
                <Grid item xs={6} className="pt-2">
                    <Controller
                        control={control}
                        name="city"
                        defaultValue=""
                        rules={{ required: true }}
                        render={({ field: { ref, value, onChange } }: any) => (
                            <BaseCreatableSelect
                                label="City"
                                options={cities}
                                value={value}
                                onChange={(e: any) => {
                                    onChange(e)
                                    onHandleSelect(e, 'CITY')
                                }}
                                // inputRef={ref}
                                fullWidth
                                className={classesInput}
                                error={errors?.city && true}
                                helperText={FormService.getErrorMessage(
                                    errors,
                                    'city',
                                    'City'
                                )}
                                disabled={disabled}
                            />
                        )}
                    />
                </Grid>
                <Grid item xs={6} className="pt-2">
                    <Controller
                        control={control}
                        name="zip"
                        defaultValue=""
                        rules={{ required: true, minLength: 5 }}
                        render={({
                            field: { ref, value, onChange, ...field },
                        }: any) => (
                            <InputMask
                                mask="99999"
                                value={value}
                                onChange={(e: ChangeEvent<any>) => {
                                    const validatedValue = e?.target?.value
                                    onChange(
                                        validatedValue?.replaceAll('_', '')
                                    )
                                }}
                                className={classesInput}
                                disabled={disabled}
                            >
                                {(inputProps: any) => {
                                    return (
                                        <RedditTextField
                                            {...inputProps}
                                            inputRef={ref}
                                            label="Zip Code"
                                            variant="filled"
                                            className={classesInput}
                                            error={errors?.zip && true}
                                            helperText={FormService.getErrorMessage(
                                                errors,
                                                'zip',
                                                'Zip Code',
                                                'Zip Code should be 5 digit'
                                            )}
                                            disabled={disabled}
                                        />
                                    )
                                }}
                            </InputMask>
                        )}
                    />
                </Grid>
                <Grid item xs={6} className="pt-2">
                    <Controller
                        control={control}
                        name="confirmationCode"
                        defaultValue=""
                        rules={{ required: true }}
                        render={({
                            field: { ref, value, onChange, ...field },
                        }: any) => (
                            <RedditTextField
                                {...field}
                                value={value}
                                onChange={onChange}
                                inputRef={ref}
                                label="Confirmation Code"
                                variant="filled"
                                className={classesInput}
                                error={errors?.confirmationCode && true}
                                helperText={FormService.getErrorMessage(
                                    errors,
                                    'confirmationCode',
                                    'Confirmation Code'
                                )}
                                disabled={disabled}
                            />
                        )}
                    />
                </Grid>
                <Grid item xs={6} container spacing={1} className="pt-2">
                    <Grid item xs={6} className="pt-2">
                        <Controller
                            control={control}
                            name="startedAt"
                            defaultValue={null}
                            rules={{ required: true }}
                            render={({
                                field: { ref, value, onChange },
                            }: any) => (
                                <BaseDatePicker
                                    label="Start Date"
                                    onChange={onChange}
                                    value={value}
                                    fullWidth
                                    inputRef={ref}
                                    // minDate={moment().subtract(2, 'weeks')}
                                    maxDate={
                                        watch?.endedAt
                                            ? new Date(watch?.endedAt)
                                            : null
                                    }
                                    error={errors?.startedAt && true}
                                    helperText={FormService.getErrorMessage(
                                        errors,
                                        'startedAt',
                                        'Start Date'
                                    )}
                                    disabled={disabled}
                                />
                            )}
                        />
                    </Grid>
                    <Grid item xs={6} className="pt-2">
                        <Controller
                            control={control}
                            name="endedAt"
                            defaultValue={null}
                            rules={{ required: true }}
                            render={({
                                field: { ref, value, onChange },
                            }: any) => (
                                <BaseDatePicker
                                    label="End Date"
                                    onChange={onChange}
                                    value={value}
                                    inputRef={ref}
                                    fullWidth
                                    minDate={
                                        watch?.startedAt
                                            ? new Date(watch?.startedAt)
                                            : null
                                    }
                                    // maxDate={new Date()}
                                    error={errors?.endedAt && true}
                                    helperText={FormService.getErrorMessage(
                                        errors,
                                        'endedAt',
                                        'End Date'
                                    )}
                                    disabled={disabled}
                                />
                            )}
                        />
                    </Grid>
                </Grid>
                <Grid item xs={6} className="pt-2">
                    <Controller
                        control={control}
                        name="coverage"
                        defaultValue=""
                        // rules={{ required: true }}
                        render={({
                            field: { ref, value, onChange, ...field },
                        }: any) => (
                            <BaseSelect
                                label="Coverage"
                                options={[CNoneOption, ...coverageOptions]}
                                value={value}
                                onChange={onChange}
                                inputRef={ref}
                                fullWidth
                                className={classesInput}
                                error={errors?.coverage && true}
                                helperText={FormService.getErrorMessage(
                                    errors,
                                    'coverage',
                                    'Coverage'
                                )}
                                disabled={disabled}
                            />
                        )}
                    />
                </Grid>
                <Grid item xs={6} className="pt-2">
                    <Controller
                        control={control}
                        name="policy"
                        defaultValue=""
                        // rules={{ required: true }}
                        render={({
                            field: { ref, value, onChange, ...field },
                        }: any) => (
                            <RedditTextField
                                {...field}
                                value={value}
                                onChange={onChange}
                                inputRef={ref}
                                label="policy"
                                variant="filled"
                                className={classesInput}
                                error={errors?.policy && true}
                                helperText={FormService.getErrorMessage(
                                    errors,
                                    'policy',
                                    'Policy #'
                                )}
                                disabled={disabled}
                            />
                        )}
                    />
                </Grid>
            </Grid>
        </Grid>
    )
}

// stores section
const mapStateToProps = (store: any) => {
    const { states, cities } = store?.tempAuth
    return {
        states,
        cities,
    }
}

const mapDispatchToProps = (dispatch: Redux.Dispatch) => {
    const { getReground, clearReground } = AuthAction
    return {
        getReground: (type: string, parentId: string, stepTwo?: string) =>
            dispatch(getReground(type, parentId, stepTwo) as any),
        clearReground: (types: string[]) =>
            dispatch(clearReground(types) as any),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(InsuranceForm)
